import React, { useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { commerceCartAddProduct } from '@uncinc/react-drupal-core';
import { QuantityPicker } from 'react-qty-picker';
import { Button, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';

import { formatPrice } from '../../../helpers/commerce';
import WysiwygField from '../../WysiwygField';

import './style.scss';

const GenericProduct = ({ entity, isSmall }) => {
  const dispatch = useDispatch();

  const [quantity, setQuantity] = useState(1);
  const [variationIndex, setVariationIndex] = useState(0);


  const onOrderClick = () => {
    dispatch(commerceCartAddProduct(entity.getIn(['variations', variationIndex, 'target_uuid']), quantity));
  };

  const onVariationChange = (index) => {
    if (!index) {
      index = 0;
    }
    setVariationIndex(index);
  };

  const variationPrice = entity.getIn(['variations', variationIndex, 'price', 'number']);
  const body = entity.getIn(['body', 0, 'processed'], '');

  const hasMultipleVariations = entity.getIn(['variations']).size > 1;

  const options = entity.getIn(['variations']).map((variation, index) => (
    { value: index, label: `Variant ${index + 1}` }
  )).toArray();

  return (
    <div className="Paragraph ParagraphCTA Product">
      <div className="ParagraphCTA__inner Product__inner">
        <div className="ParagraphCTA__body Product__body">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-12 col-xl-6">
              <h3 className="Product__title">{entity.getIn(['title', 0, 'value'], '')}</h3>
              <WysiwygField
                className="Product__description subheading2"
                property="schema:text"
                html={body}
              />
            </div>
            <div className={classNames('Product__wrapper col-12 col-md-6 col-lg-12 col-xl-6', { variant: hasMultipleVariations })}>
              <h3 className="Product__Price">&euro; {formatPrice(variationPrice)} <span>excl. BTW en evt. verzendkosten</span></h3>

              {entity.getIn(['status', 0, 'value']) && (
                <>
                  {hasMultipleVariations && (
                    <FormikWrapper>
                      <Select
                        required
                        placeholder="Kies een variant"
                        fieldName="product_variation"
                        options={options}
                        onChange={onVariationChange}
                      />
                    </FormikWrapper>
                  )}

                  <div className="Product__orderBar">
                    <QuantityPicker min={1} max={10} value={quantity} onChange={(value) => setQuantity(value)} width="2rem" />
                    <Button
                      to="#"
                      className="Button--primary Button--order"
                      onClick={onOrderClick}
                    >
                      Bestellen
                      <div className="icon icon-shopping-cart icon-variant-2" />
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericProduct;
